module.exports = __webpack_public_path__ + "static/media/Ottowa.473e1235.png";